export default __webpack_public_path__ + "static/Poppins-Bold-02d30d49f061087e62755835b35d8a08.woff2";